"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[632],{

/***/ 62659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ view_CVApplicationViewComponent; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./hooks/useToasts/useToasts.ts
var useToasts = __webpack_require__(57064);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/manfredite-job-application.service.ts
var manfredite_job_application_service = __webpack_require__(72971);
// EXTERNAL MODULE: ./utils/errors.ts
var errors = __webpack_require__(31386);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/publicProfile/timeline/PublicProfileTimelineComponent.tsx + 11 modules
var PublicProfileTimelineComponent = __webpack_require__(30860);
// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./services/ui/publicprofile/publicprofile.service.ts
var publicprofile_service = __webpack_require__(27595);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./components/publicProfile/classic/PublicProfileClassic.tsx + 64 modules
var PublicProfileClassic = __webpack_require__(6897);
// EXTERNAL MODULE: ./components/publicProfile/pdf/PublicProfilePdfComponent.tsx + 19 modules
var PublicProfilePdfComponent = __webpack_require__(32162);
;// CONCATENATED MODULE: ./components/publicProfile/PublicProfileComponent.tsx












var PublicProfileComponent = function(param) {
    var _type = param.type, type = _type === void 0 ? "timeline" : _type, publicManfredite = param.publicManfredite, slug = param.slug, isDefaultView = param.isDefaultView, _sendVisitTrackEvent = param.sendVisitTrackEvent, sendVisitTrackEvent = _sendVisitTrackEvent === void 0 ? true : _sendVisitTrackEvent;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var uiPublicManfredite = publicprofile_service/* default.getManfrediteUIData */.Z.getManfrediteUIData(publicManfredite, locale);
    var ref1 = publicprofile_service/* default.getManfrediteProfileMetadataInfo */.Z.getManfrediteProfileMetadataInfo(uiPublicManfredite, t), title = ref1.title, desc = ref1.desc, avatarUrl = ref1.avatarUrl;
    var profileUrlPathToView = isDefaultView ? "" : "/" + type;
    var profileUrlPath = "".concat(slug).concat(profileUrlPathToView);
    (0,react.useEffect)(function() {
        var ref;
        if (loadingUser) {
            return;
        }
        if (sendVisitTrackEvent && slug && (!user || ((ref = user.configuration) === null || ref === void 0 ? void 0 : ref.publicProfileSlug) !== slug)) {
            service_event_tracking/* default.track */.Z.track({
                type: "Website - Public Profile Viewed",
                properties: {
                    url: window.location.href,
                    title: title,
                    slug: slug,
                    type: type
                }
            });
        }
    }, [
        loadingUser
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            slug && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: title,
                desc: desc,
                imgUrl: avatarUrl,
                url: app_urls/* APP_URLS.manfrediteProfileV2 */.uu.manfrediteProfileV2,
                path: {
                    ES: profileUrlPath,
                    EN: profileUrlPath
                }
            }),
            (!type || type === "timeline") && /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicProfileTimelineComponent/* default */.Z, {
                publicManfredite: uiPublicManfredite
            }),
            type === "classic" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicProfileClassic/* default */.Z, {
                manfredite: uiPublicManfredite
            }),
            type === "pdf" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicProfilePdfComponent/* default */.Z, {
                publicManfredite: uiPublicManfredite,
                slug: slug
            })
        ]
    });
};
/* harmony default export */ var publicProfile_PublicProfileComponent = (PublicProfileComponent);

// EXTERNAL MODULE: ./components/shared/Button.styled.tsx
var Button_styled = __webpack_require__(59760);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ./components/shared/Dropdown.tsx + 1 modules
var Dropdown = __webpack_require__(25728);
// EXTERNAL MODULE: ./services/multilingual.service.ts
var multilingual_service = __webpack_require__(21428);
// EXTERNAL MODULE: ./components/shared/MarkdownComponent.tsx
var MarkdownComponent = __webpack_require__(57792);
// EXTERNAL MODULE: ./components/shared/Modal.tsx
var Modal = __webpack_require__(61897);
// EXTERNAL MODULE: ../../node_modules/react-modal/lib/index.js
var lib = __webpack_require__(37149);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/cvApplications/view/coverLetter/CVApplicationsCoverLetterModalComponent.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  li {\n    margin-left: ",
        ";\n    list-style-type: disc;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b3be7968-0"
})(_templateObject(), (0,theme/* spacing */.W0)("lg"));

;// CONCATENATED MODULE: ./components/cvApplications/view/coverLetter/CVApplicationsCoverLetterModalComponent.tsx






var CVApplicationsCoverLetterModalComponent = function(param) {
    var isOpen = param.isOpen, coverLetter = param.coverLetter, close = param.close;
    var t = (0,useI18n/* useI18n */.Q)("cv-applications-view").t;
    var title = t("cvApplicationsView.modalCoverLetter.title");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        isOpen: isOpen,
        contentLabel: title,
        onRequestClose: close,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            onClose: close,
            title: title,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                    content: coverLetter
                })
            })
        })
    });
};
/* harmony default export */ var coverLetter_CVApplicationsCoverLetterModalComponent = (CVApplicationsCoverLetterModalComponent);

;// CONCATENATED MODULE: ./components/cvApplications/view/CVApplicationTermsAcceptedComponent.styled.ts

function CVApplicationTermsAcceptedComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        ";\n"
    ]);
    CVApplicationTermsAcceptedComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      text-align: left;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        justify-content: center;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: ",
        ";\n  text-align: center;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: ",
        ";\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n\n  ",
        " {\n    flex: 0 0 auto;\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: flex;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 auto;\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var CVApplicationTermsAcceptedComponent_styled_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-800b2627-0"
})(CVApplicationTermsAcceptedComponent_styled_templateObject(), (0,theme/* spacing */.W0)("xl6"));
var StyledFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-800b2627-1"
})(_templateObject3(), (0,theme/* color */.$_)("midnight_850"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("lg"), (0,theme/* zindex */.Y0)("bottomBar"), function(param) {
    var previewMode = param.previewMode;
    return previewMode && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
}, function(param) {
    var previewMode = param.previewMode;
    return !previewMode && (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), StyledFooterActions);
});
var StyledFooterActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-800b2627-2"
})(_templateObject4(), (0,theme/* spacing */.W0)("md"), Button_styled/* default */.Z);
var StyledFooterTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-800b2627-3"
})(_templateObject5());
var StyledFooterButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-800b2627-4"
})(_templateObject6(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"));
var StyledFooterMobileButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-800b2627-5"
})(_templateObject7(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"));
var StyledFooterMobileDropUp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-800b2627-6"
})(_templateObject8());
var StyledFooterEdit = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-800b2627-7"
})(_templateObject9());
var StyledFooterHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-800b2627-8"
})(_templateObject10(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("md"));

// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-duotone-svg-icons/index.mjs
var pro_duotone_svg_icons = __webpack_require__(82655);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/Modal.styled.ts
var Modal_styled = __webpack_require__(75885);
// EXTERNAL MODULE: ../utils/dist/esm/index.js + 3 modules
var esm = __webpack_require__(74679);
// EXTERNAL MODULE: ./services/manfredite-file.service.ts
var manfredite_file_service = __webpack_require__(5577);
// EXTERNAL MODULE: ./utils/i18n.ts
var i18n = __webpack_require__(63898);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(24511);
;// CONCATENATED MODULE: ./utils/yup.ts

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
var yup_yupOptionalListItemArray = function(opts) {
    var ref = opts || {
        limit: 0
    }, limit = ref.limit, limitMessage = ref.limitMessage;
    if (limit) {
        return yup.array().nullable().max(limit, limitMessage).of(yup.object().shape({
            label: yup.string(),
            value: yup.number()
        }));
    }
    return yup.array().nullable().of(yup.object().shape({
        label: yup.string(),
        value: yup.number()
    }));
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
var yupRequiredListItemArray = function(msg) {
    return yup.array().min(1, msg).required(msg).of(yup.object().shape({
        label: yup.string(),
        value: yup.number()
    }));
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
var yup_yupOptionalListItem = function() {
    return yup.object().nullable().shape({
        label: yup.string(),
        value: yup.number()
    });
};
var yup_yupMultilingual = function() {
    return yup.object().shape({
        ES: yup.string(),
        EN: yup.string()
    });
};

;// CONCATENATED MODULE: ./services/ui/profile.service.ts










function getExperienceLabel(param, locale) {
    var min = param.min, max = param.max;
    if (min && !max) {
        return (0,i18n/* getTranslation */.i)("experience.min", "common", locale, {
            min: min
        });
    }
    if (!min && max) {
        return (0,i18n/* getTranslation */.i)("experience.max", "common", locale, {
            max: max
        });
    }
    if (min === 0 && max === 0) {
        return (0,i18n/* getTranslation */.i)("experience.equal", "common", locale);
    }
    return (0,i18n/* getTranslation */.i)("experience.minMax", "common", locale, {
        min: min,
        max: max
    });
}
function getAttachmentsIds(attachments) {
    return _getAttachmentsIds.apply(this, arguments);
}
function _getAttachmentsIds() {
    _getAttachmentsIds = _async_to_generator(function(attachments) {
        var ids;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    ids = [];
                    return [
                        4,
                        asyncForEach(attachments, function() {
                            var _ref = _async_to_generator(function(attachment) {
                                var type, currentId, formValue, setMediaState, media, media1;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            type = attachment.type, currentId = attachment.currentId, formValue = attachment.formValue, setMediaState = attachment.setMediaState, media = attachment.media;
                                            if (!(formValue && formValue.length > 0)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                uploadManfrediteFile(formValue[0], type)
                                            ];
                                        case 1:
                                            media1 = _state.sent();
                                            ids.push(media1.id);
                                            setMediaState(media1);
                                            return [
                                                3,
                                                5
                                            ];
                                        case 2:
                                            if (!(currentId && (!formValue || formValue.length <= 0) && !media)) return [
                                                3,
                                                4
                                            ];
                                            return [
                                                4,
                                                deleteFile(currentId)
                                            ];
                                        case 3:
                                            _state.sent();
                                            ids.push(undefined);
                                            return [
                                                3,
                                                5
                                            ];
                                        case 4:
                                            ids.push(currentId);
                                            _state.label = 5;
                                        case 5:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(attachment) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        ids
                    ];
            }
        });
    });
    return _getAttachmentsIds.apply(this, arguments);
}
/**
 * Returns the Yup validation schema for the Profile (Manfredite) form
 *
 * @param t - translation function (from next-i18n) for validation messages
 * @returns the validation schema for Profile Form
 */ function getProfileFormValidationSchema(t) {
    return yup.object().shape({
        name: yup.string().nullable(),
        surname: yup.string().nullable(),
        about: yup.string().nullable(),
        headline: yup.string().nullable(),
        whereDoYouLive: yup.object().shape({
            displayName: yupMultilingual(),
            placeId: yup.string()
        }).nullable(),
        softSkills: yupOptionalListItemArray({
            limit: 3,
            limitMessage: t("messages.error.maxSoftSkills", {
                count: 3
            })
        }),
        roles: yupOptionalListItemArray(),
        techs: yupOptionalListItemArray(),
        techsLike: yupOptionalListItemArray(),
        techsDislike: yupOptionalListItemArray(),
        bestPractices: yup.string().nullable(),
        languages: yupOptionalListItemArray(),
        facts: yup.array().nullable().of(yup.object().shape({
            title: yup.string(),
            description: yup.string()
        })),
        experience: yupOptionalListItem(),
        linkedIn: yup.string().nullable().matches(URL_OR_EMPTY_REGEX, t("messages.error.invalidUrl")),
        cv: yup.mixed().nullable(),
        mac: yup.mixed().nullable(),
        avatar: yup.mixed().nullable(),
        idealWorkplace: yup.string().nullable(),
        range: yupOptionalListItem(),
        rangeComment: yup.string().nullable(),
        phoneNumber: yup.string().nullable().test("is-possible-number", t("messages.error.invalidPhoneNumber"), function(value) {
            return value ? isPossiblePhoneNumber(value) : true;
        }),
        subscribe: yup.boolean().nullable(),
        locationTypeRemote: yup.boolean().nullable(),
        locationTypePartiallyRemote: yup.boolean().nullable().test({
            name: "max",
            exclusive: false,
            message: t("messages.error.invalidLocation"),
            test: function test(value) {
                var _parent = this.parent, workPlaces = _parent.workPlaces, locationAnywhere = _parent.locationAnywhere;
                if (value && (!workPlaces || workPlaces.length <= 0) && !locationAnywhere) {
                    return false;
                }
                return true;
            }
        }),
        locationTypeFaceToFace: yup.boolean().nullable().test({
            name: "max",
            exclusive: false,
            message: t("messages.error.invalidLocation"),
            test: function test(value) {
                var _parent = this.parent, workPlaces = _parent.workPlaces, locationAnywhere = _parent.locationAnywhere;
                if (value && (!workPlaces || workPlaces.length <= 0) && !locationAnywhere) {
                    return false;
                }
                return true;
            }
        }),
        locationAnywhere: yup.bool().nullable(),
        workPlaces: yup.array(yup.object().shape({
            displayName: yupMultilingual(),
            placeId: yup.string()
        })).nullable(),
        workPlacesComment: yup.string().nullable(),
        socialLinks: yup.object().shape({
            twitter: yup.string().nullable().matches(TWITTER_URL_OR_EMPTY_REGEX, t("messages.error.invalidUrlTwitter")),
            stackoverflow: yup.string().nullable().matches(SO_URL_OR_EMPTY_REGEX, t("messages.error.invalidUrlStackOverflow")),
            github: yup.string().nullable().matches(GITHUB_URL_OR_EMPTY_REGEX, t("messages.error.invalidUrlGitHub")),
            others: yup.array().nullable().of(yup.object().shape({
                url: yup.string().nullable().matches(URL_OR_EMPTY_REGEX, t("messages.error.invalidUrl")),
                desc: yup.string().nullable()
            }))
        })
    });
}
/**
 * @deprecated Use `mergeTechsListItemWithNotActiveTechs`
 */ function getAvailableTechsListItems(techsSelected, items) {
    if (!techsSelected) {
        return [];
    }
    var disabledTechs = ((techsSelected === null || techsSelected === void 0 ? void 0 : techsSelected.filter(function(tech) {
        return tech.enabled === false;
    })) || []).map(function(l) {
        return {
            label: l.name,
            value: l.id
        };
    });
    return _to_consumable_array(disabledTechs).concat(_to_consumable_array(items || []));
}
function mergeTechsListItemWithNotActiveTechs(enabledTechsListItems, techs) {
    return getAvailableTechsListItems(techs || [], enabledTechsListItems);
}

// EXTERNAL MODULE: ./utils/config.ts
var config = __webpack_require__(75339);
;// CONCATENATED MODULE: ./components/cvApplications/view/termsAndConditions/CVApplicationsTermsModalComponent.styled.ts

function CVApplicationsTermsModalComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ReactModal__Overlay {\n    background-color: rgba(53,50,65,0.35) !important;\n  }\n"
    ]);
    CVApplicationsTermsModalComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CVApplicationsTermsModalComponent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    CVApplicationsTermsModalComponent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CVApplicationsTermsModalComponent_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  padding: ",
        ";\n  margin-bottom: ",
        ";\n\n  h5 {\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    text-transform: uppercase;\n    margin-top: 0;\n    margin-bottom: ",
        ";\n  }\n\n  li {\n    list-style-type: disc;\n    margin-left: 1rem;\n  }\n"
    ]);
    CVApplicationsTermsModalComponent_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CVApplicationsTermsModalComponent_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    CVApplicationsTermsModalComponent_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CVApplicationsTermsModalComponent_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n\n  li {\n    list-style-type: disc;\n    margin-left: 1rem;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    CVApplicationsTermsModalComponent_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var GlobalStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(CVApplicationsTermsModalComponent_styled_templateObject());
var CVApplicationsTermsModalComponent_styled_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22d40ba-0"
})(CVApplicationsTermsModalComponent_styled_templateObject1());
var StyledInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22d40ba-1"
})(CVApplicationsTermsModalComponent_styled_templateObject2(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("midnight_500"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("sm"));
var StyledSubtitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-22d40ba-2"
})(CVApplicationsTermsModalComponent_styled_templateObject3(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("md"));
var StyledTerms = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-22d40ba-3"
})(CVApplicationsTermsModalComponent_styled_templateObject4(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"));

;// CONCATENATED MODULE: ./components/cvApplications/view/termsAndConditions/CVApplicationsTermsModalComponent.tsx






















var CVApplicationsTermsModalComponent = function(param) {
    var isOpen = param.isOpen, jobApplicationResume = param.jobApplicationResume, onAccept = param.onAccept, _alreadyAccepted = param.alreadyAccepted, alreadyAccepted = _alreadyAccepted === void 0 ? false : _alreadyAccepted, close = param.close;
    var ref;
    var t = (0,useI18n/* useI18n */.Q)("cv-applications-view").t;
    var locale = (0,router.useRouter)().locale;
    var addErrorToast = (0,useToasts/* useToasts */.e)().addErrorToast;
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var moreInfoLink = "".concat(config/* config.appUrl */.v.appUrl, "/").concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.cvApplicationsLanding */.uu.cvApplicationsLanding, locale), "#jobAppsCompanies");
    var title = alreadyAccepted ? t("cvApplicationsView.modalTerms.titleAlreadyAccepted") : t("cvApplicationsView.modalTerms.title", {
        fullName: "".concat(jobApplicationResume.firstName, " ").concat(jobApplicationResume.lastName).trim()
    });
    var roles = (ref = jobApplicationResume.roles) === null || ref === void 0 ? void 0 : ref.map(function(role) {
        return (0,multilingual_service/* getTranslatedText */.G)(role.name, locale);
    });
    var experience = jobApplicationResume.experience ? getExperienceLabel(jobApplicationResume.experience, locale) : undefined;
    var position = (0,multilingual_service/* getTranslatedText */.G)(jobApplicationResume.jobPosition, locale);
    var company = (0,multilingual_service/* getTranslatedText */.G)(jobApplicationResume.companyName, locale);
    var onAcceptClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ex;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!onAccept) {
                            return [
                                2
                            ];
                        }
                        setIsLoading(true);
                        return [
                            4,
                            onAccept()
                        ];
                    case 1:
                        _state.sent();
                        setIsLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        ex = _state.sent();
                        setIsLoading(false);
                        addErrorToast(t("cvApplicationsView.modalTerms.messages.error.acceptTerms", {
                            error: (0,errors/* getErrorMessage */.e)(ex)
                        }));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onAcceptClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        isOpen: isOpen,
        contentLabel: title,
        onRequestClose: close,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            title: title,
            onClose: close,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CVApplicationsTermsModalComponent_styled_StyledWrapper, {
                    children: [
                        !alreadyAccepted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInfo, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            children: t("cvApplicationsView.modalTerms.info.title")
                                        }),
                                        (roles || experience) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                roles && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                        ns: "cv-applications-view",
                                                        i18nKey: "cvApplicationsView.modalTerms.info.roles",
                                                        values: {
                                                            roles: roles
                                                        }
                                                    })
                                                }),
                                                experience && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                        ns: "cv-applications-view",
                                                        i18nKey: "cvApplicationsView.modalTerms.info.experience",
                                                        values: {
                                                            experience: experience
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubtitle, {
                                    children: t("cvApplicationsView.modalTerms.terms.title")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTerms, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                        ns: "cv-applications-view",
                                        i18nKey: "cvApplicationsView.modalTerms.terms.term1",
                                        values: {
                                            company: company
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        position && /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                            ns: "cv-applications-view",
                                            i18nKey: "cvApplicationsView.modalTerms.terms.term2",
                                            values: {
                                                position: position,
                                                company: company
                                            }
                                        }),
                                        !position && /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                            ns: "cv-applications-view",
                                            i18nKey: "cvApplicationsView.modalTerms.terms.term2_noposition",
                                            values: {
                                                company: company
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                        ns: "cv-applications-view",
                                        i18nKey: "cvApplicationsView.modalTerms.terms.term3"
                                    })
                                })
                            ]
                        }),
                        !alreadyAccepted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_styled/* StyledModalActions */.BL, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_styled/* default */.Z, {
                                    onClick: onAcceptClick,
                                    isLoading: isLoading,
                                    children: [
                                        !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                                        }),
                                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_duotone_svg_icons/* faSpinnerThird */.AX7,
                                            spin: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("cvApplicationsView.modalTerms.actions.accept")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                                    href: moreInfoLink,
                                    target: "_blank",
                                    variant: "tertiaryEmerald",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faInfoCircle */.sqG
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("cvApplicationsView.modalTerms.actions.moreInfo")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles, {})
            ]
        })
    });
};
/* harmony default export */ var termsAndConditions_CVApplicationsTermsModalComponent = (CVApplicationsTermsModalComponent);

;// CONCATENATED MODULE: ./components/cvApplications/view/CVApplicationTermsAcceptedComponent.tsx















var CVApplicationTermsAcceptedComponent = function(param) {
    var publicManfredite = param.publicManfredite, cvApplication = param.cvApplication, jobApplicationResume = param.jobApplicationResume, _previewMode = param.previewMode, previewMode = _previewMode === void 0 ? false : _previewMode;
    var t = (0,useI18n/* useI18n */.Q)("cv-applications-view").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)(false), termsModalOpened = ref[0], setTermsModalOpened = ref[1];
    var ref1 = (0,react.useState)(false), coverLetterModalOpened = ref1[0], setCoverLetterModalOpened = ref1[1];
    var hasCoverLetter = cvApplication.enableCoverLetter;
    var hasPrivacyTerms = cvApplication.enablePrivacyTerms;
    (0,react.useEffect)(function() {
        setCoverLetterModalOpened(hasCoverLetter);
    }, [
        hasCoverLetter
    ]);
    var ref2 = (0,react.useState)(false), mobileActionsMenuOpen = ref2[0], setMobileActionsMenuOpen = ref2[1];
    var dropdown = (0,react.useRef)(null);
    var handleCloseMobileActionsMenuClick = function(e) {
        var ref;
        if ((ref = dropdown.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)) {
            return;
        }
        setMobileActionsMenuOpen(false);
    };
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleCloseMobileActionsMenuClick);
        return function() {
            document.removeEventListener("mousedown", handleCloseMobileActionsMenuClick);
        };
    }, []);
    var mobileActions = [
        {
            label: t("cvApplicationsView.termsAccepted.footer.privacyTerms_short"),
            value: t("cvApplicationsView.termsAccepted.footer.privacyTerms_short"),
            action: function() {
                return setTermsModalOpened(true);
            }
        },
        {
            label: t("cvApplicationsView.termsAccepted.footer.coverLetter_short"),
            value: t("cvApplicationsView.termsAccepted.footer.coverLetter_short"),
            action: function() {
                return setCoverLetterModalOpened(true);
            }
        }
    ];
    var withoutTermsAndLetter = !hasPrivacyTerms && !hasCoverLetter;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CVApplicationTermsAcceptedComponent_styled_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(publicProfile_PublicProfileComponent, {
                publicManfredite: publicManfredite,
                slug: publicManfredite.slug,
                type: cvApplication.view,
                isDefaultView: false,
                sendVisitTrackEvent: false
            }),
            (hasPrivacyTerms || hasCoverLetter || previewMode) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooter, {
                previewMode: previewMode,
                children: [
                    previewMode && !withoutTermsAndLetter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooterHeader, {
                        children: t("cvApplicationsView.termsAccepted.footer.header")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterActions, {
                        children: [
                            previewMode && withoutTermsAndLetter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooterTag, {
                                children: t("cvApplicationsView.termsAccepted.footer.header")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterButtons, {
                                children: [
                                    hasPrivacyTerms && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_styled/* default */.Z, {
                                        sizes: "sm",
                                        variant: "secondaryInverse",
                                        onClick: function() {
                                            return setTermsModalOpened(true);
                                        },
                                        "aria-label": t("cvApplicationsView.termsAccepted.footer.privacyTerms"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                "aria-hidden": true,
                                                icon: pro_solid_svg_icons/* faFileLines */.nfZ
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                "aria-hidden": true,
                                                children: t("cvApplicationsView.termsAccepted.footer.privacyTerms")
                                            })
                                        ]
                                    }),
                                    hasCoverLetter && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_styled/* default */.Z, {
                                        sizes: "sm",
                                        variant: "secondaryInverse",
                                        onClick: function() {
                                            return setCoverLetterModalOpened(true);
                                        },
                                        "aria-label": t("cvApplicationsView.termsAccepted.footer.coverLetter"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                "aria-hidden": true,
                                                icon: pro_solid_svg_icons/* faEnvelopeOpenText */.mSY
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                "aria-hidden": true,
                                                children: t("cvApplicationsView.termsAccepted.footer.coverLetter")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterMobileButtons, {
                                children: [
                                    (hasPrivacyTerms && !hasCoverLetter && previewMode || hasPrivacyTerms && !previewMode) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_styled/* default */.Z, {
                                        sizes: "sm",
                                        variant: "secondaryInverse",
                                        onClick: function() {
                                            return setTermsModalOpened(true);
                                        },
                                        "aria-label": t("cvApplicationsView.termsAccepted.footer.privacyTerms"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                "aria-hidden": true,
                                                icon: pro_solid_svg_icons/* faFileLines */.nfZ
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                "aria-hidden": true,
                                                children: t("cvApplicationsView.termsAccepted.footer.privacyTerms_short")
                                            })
                                        ]
                                    }),
                                    (hasCoverLetter && !hasPrivacyTerms && previewMode || hasCoverLetter && !previewMode) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_styled/* default */.Z, {
                                        sizes: "sm",
                                        variant: "secondaryInverse",
                                        onClick: function() {
                                            return setCoverLetterModalOpened(true);
                                        },
                                        "aria-label": t("cvApplicationsView.termsAccepted.footer.coverLetter"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                "aria-hidden": true,
                                                icon: pro_solid_svg_icons/* faEnvelopeOpenText */.mSY
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                "aria-hidden": true,
                                                children: t("cvApplicationsView.termsAccepted.footer.coverLetter_short")
                                            })
                                        ]
                                    }),
                                    hasCoverLetter && hasPrivacyTerms && previewMode && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterMobileDropUp, {
                                        ref: dropdown,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_styled/* default */.Z, {
                                                sizes: "sm",
                                                variant: "secondaryInverse",
                                                "aria-controls": "cv-application-preview-actions-dropdown",
                                                onClick: function() {
                                                    return setMobileActionsMenuOpen(!mobileActionsMenuOpen);
                                                },
                                                "aria-label": t("cvApplicationsView.termsAccepted.footer.showActions"),
                                                isTrigger: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        "aria-hidden": true,
                                                        icon: pro_solid_svg_icons/* faEye */.Mdf
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        "aria-hidden": true,
                                                        children: t("cvApplicationsView.termsAccepted.footer.showActions")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                                id: "cv-application-actions-dropdown",
                                                options: mobileActions,
                                                isDropUp: true,
                                                isAlignLeft: true,
                                                style: {
                                                    display: mobileActionsMenuOpen ? "block" : "none"
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            previewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooterEdit, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                                    sizes: "sm",
                                    variant: "tertiaryInverse",
                                    href: "/".concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.portalV2Dashboard */.uu.portalV2Dashboard, locale)),
                                    target: "_blank",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            "aria-hidden": true,
                                            icon: pro_solid_svg_icons/* faPen */.IwR
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("cvApplicationsView.termsAccepted.footer.editProfile")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            hasPrivacyTerms && jobApplicationResume && /*#__PURE__*/ (0,jsx_runtime.jsx)(termsAndConditions_CVApplicationsTermsModalComponent, {
                isOpen: termsModalOpened,
                alreadyAccepted: true,
                close: function() {
                    setTermsModalOpened(false);
                },
                jobApplicationResume: jobApplicationResume
            }),
            hasCoverLetter && /*#__PURE__*/ (0,jsx_runtime.jsx)(coverLetter_CVApplicationsCoverLetterModalComponent, {
                coverLetter: (0,multilingual_service/* getTranslatedText */.G)(cvApplication.coverLetter, locale),
                isOpen: coverLetterModalOpened,
                close: function() {
                    setCoverLetterModalOpened(false);
                }
            })
        ]
    });
};
/* harmony default export */ var view_CVApplicationTermsAcceptedComponent = (CVApplicationTermsAcceptedComponent);

// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ../common-dto/dist/esm/index.js + 55 modules
var dist_esm = __webpack_require__(34449);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/cvApplications/view/CVApplicationTermsNotAcceptedComponent.data.ts


var CvApplicationSampleManfredite = {
    headline: {
        EN: "Director of Software Engineering Division at MIT's Instrumentation Laboratory"
    },
    whereDoYouLive: {
        displayName: {
            ES: "Massachusetts, EE.UU",
            EN: "Massachusetts, USA"
        },
        placeId: "xxxxxxxx"
    },
    introduction: {
        EN: "Hi! I'm Margaret Heafield Hamilton. I'm an American computer scientist, systems engineer and business owner. Once, I was director of the Software Engineering Division of the MIT Instrumentation Laboratory, which developed on-board flight software for NASA's Apollo program. I have also founded two software companies—Higher Order Software in 1976 and Hamilton Technologies in 1986, both in Cambridge, Massachusetts."
    },
    goodPractices: {
        ES: ""
    },
    facts: [
        {
            title: {
                EN: "Some people consider myself as the first person to become a Site Reliability Engineer. Ah! Also, I coined the term Software Engineering."
            },
            description: {
                EN: "* More than 130 papers published\n* 60 projects\n* 6 major programs"
            }
        }
    ],
    profile: {
        firstName: "Margaret H.",
        lastName: "Hamilton",
        avatar: {
            url: (0,paths/* getPublicPath */.A)("/images/MargaretHHamilton.jpg"),
            alt: {
                ES: "avatar.png"
            },
            id: 1,
            title: "",
            filename: "",
            ownerId: 1,
            uploadPath: ""
        },
        links: {
            others: [
                {
                    url: "https://www.getmanfred.com/profile/margaret_hamilton",
                    desc: "About Me"
                }
            ],
            linkedin: ""
        }
    },
    softSkills: [
        {
            name: {
                EN: "Leadership skills"
            },
            description: {},
            icon: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/0af23937-4368-43bd-8846-455238c9d50e_Theme%3DLight%2C%20Category%3DSkills%2C%20Type%3DLeadership.svg",
                alt: {
                    EN: "Leadership_Skills_Icon"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            }
        },
        {
            name: {
                EN: "Team management"
            },
            description: {},
            icon: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/fceedfc0-aa24-43b2-adfd-fd045c2a393d_Theme%3DLight%2C%20Category%3DLiabilities%2C%20Type%3DFace%20to%20face.svg",
                alt: {
                    EN: "Team_Management_Icon"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            }
        },
        {
            name: {
                EN: "Analytical thinking"
            },
            description: {},
            icon: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/5a9f97a9-b652-45ec-a8b1-b2b3d0971e58_Theme%3DLight%2C%20Category%3DSkills%2C%20Type%3DPositivity.svg",
                alt: {
                    EN: "Analytical_Thinking_Icon"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            }
        }
    ],
    languages: [
        {
            name: {
                EN: "English"
            },
            level: dist_esm/* LanguageLevel.NativeBilingual */.vA.NativeBilingual
        }
    ],
    techs: [],
    techsLike: [],
    techsDislike: [],
    career: [
        {
            company: "Charles Stark Draper Laboratory at MIT",
            position: {
                ES: "Systems Designer"
            },
            from: "1963-05-01T12:00:00.000Z",
            description: {
                ES: "I was initially hired as a programmer for this process, but moved on into system designs. By 1965, I was in charge of al Command Module software, which was all the software for navigation and lunar landing guidance. All for the Apollo command module. "
            },
            to: "1976-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/56f4b69f-a224-4b1c-8174-65737961d1ed_2560px-mit_logo.png",
                alt: {
                    ES: "2560px-MIT_logo.svg.png"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            }
        },
        {
            company: "NASA (Apollo flight)",
            position: {
                ES: "Software Designer"
            },
            from: "1965-05-01T12:00:00.000Z",
            description: {
                ES: 'My "priority display" innovation had created a knock-on risk that astronaut and computer would slip out of synch just when it mattered most. As the alarms went off and priority displays replaced normal ones, the actual switchover to new programmes behind the screens was happening "a step slower" than it would today.'
            },
            to: "1970-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/37a26fdd-6b6c-4f8d-90bf-849ab7aa07d3_nasa_logo.png",
                alt: {
                    ES: "NASA_logo.svg.png"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            }
        },
        {
            company: "MIT",
            position: {
                ES: "Software Programmer at MIT Lincoln Lab"
            },
            from: "1961-05-01T12:00:00.000Z",
            description: {
                ES: "From 1961 to 1963 I worked on the Semi-Automatic Ground Environment (SAGE) Project at the MIT Lincoln Lab, where I was one of the programmers who wrote software for the Prototype AN/FSQ.7 computer, used by the U.S. Air Force to search for possibly unfriendly aircraft. "
            },
            to: "1963-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/080c93bf-c0af-437a-9d9b-77781d86d0b5_2560px-mit_logo.png",
                alt: {
                    ES: "2560px-MIT_logo.svg.png"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            }
        }
    ],
    projects: [
        {
            manfrediteId: 1,
            type: "SIDE_PROJECT",
            title: {
                ES: "Coding Software for the Apollo 11 Mission"
            },
            description: {
                ES: "I was in charge of the codification of Software for the Apollo 11 Mission, the one who took for the very first time the man to the Moon."
            },
            from: "1969-07-01T12:00:00.000Z",
            to: "1969-08-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/28/72a4a682-5519-4733-83ae-f52b0b3fbd39_nasa_logo.png",
                alt: {
                    ES: "NASA_logo.svg.png"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            }
        }
    ],
    highlights: [
        {
            type: "AWARD",
            title: {
                ES: "Computer History Museum Fellow Award"
            },
            category: {
                ES: ""
            },
            description: {
                ES: "Which honors exceptional men and women whose computing ideas have changed the world."
            },
            date: "2017-04-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/7e83380f-7aff-43e3-811b-537ccff84817_fa-gallery-05.jpg",
                alt: {
                    ES: "fa-gallery-05.jpg"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            }
        },
        {
            type: "AWARD",
            title: {
                ES: "The Washington Award"
            },
            category: {
                ES: ""
            },
            description: {
                ES: ""
            },
            date: "2019-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/08/01/d8acad74-d7ca-48c2-a12e-405a3668c1c1_imatge-(1).jpg",
                alt: {
                    ES: "imatge (1).jpg"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            },
            url: "https://en.wikipedia.org/wiki/Washington_Award"
        },
        {
            type: "AWARD",
            title: {
                ES: "Honorary Doctorate by Bard College"
            },
            category: {
                ES: ""
            },
            description: {
                ES: ""
            },
            date: "2019-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/08/01/f10dca88-3916-4e35-9810-892e3b020c2a_imatge1.jpg",
                alt: {
                    ES: "imatge1.jpg"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            },
            url: "https://www.technologyreview.com/2019/08/16/579/margaret-hamilton/"
        },
        {
            type: "AWARD",
            title: {
                ES: "US Presidential Medal of Freedom"
            },
            category: {
                ES: ""
            },
            description: {
                ES: "From Barack Obama, the highest civilian honor in the United States."
            },
            date: "2016-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/08/01/a9934965-37ba-4d9a-8d70-4359cce5df36_625098110.jpeg",
                alt: {
                    ES: "625098110.0.jpeg"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            },
            url: "https://www.theverge.com/2016/11/23/13734214/apollo-software-engineer-margaret-hamilton-presidential-medal-of-freedom"
        },
        {
            type: "AWARD",
            title: {
                ES: "Honorary Doctorate by the Polythecnic University of Catalonia"
            },
            category: {
                ES: ""
            },
            description: {
                ES: ""
            },
            date: "2018-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/08/01/a14e090a-0797-494f-9056-3436a3bf57e6_imatge.jpg",
                alt: {
                    ES: "imatge.jpg"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            },
            url: "https://www.upc.edu/en/press-room/news/investiture-of-margaret-hamilton-as-an-honorary-doctor-of-upc"
        },
        {
            type: "AWARD",
            title: {
                ES: "Outstanding Alumni Award"
            },
            category: {
                ES: ""
            },
            description: {
                ES: "Given by Earlham College"
            },
            date: "2009-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/08/01/df317b05-2779-4b2e-a5ad-357e1fc00f68_divyjwax0aackns.jpg",
                alt: {
                    ES: "DiVYJwaX0AACKNS.jpg"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            },
            url: "https://engineerbabu.com/blog/margaret-hamilton/#:~:text=Margaret%20Hamilton%20was%20honored%20by,Alumni%20Award%20from%20Earlham%20College."
        },
        {
            type: "AWARD",
            title: {
                ES: "Augusta Ada Lovelace"
            },
            category: {
                ES: "Award"
            },
            description: {
                ES: "Given by the Association for Women in Computing."
            },
            date: "1986-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/08/01/c482397f-c057-49e2-ae98-cf62d4b11338_maxresdefault.jpg",
                alt: {
                    ES: "maxresdefault.jpg"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            },
            url: "https://en.wikipedia.org/wiki/Ada_Lovelace_Award"
        },
        {
            type: "AWARD",
            title: {
                ES: "NASA Exceptional Space Act Award"
            },
            category: {
                ES: ""
            },
            description: {
                ES: "The award included $37,200, the largest amount awarded to any individual in NASA's history."
            },
            date: "2003-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/a884b9a1-6531-426b-81ba-2f9a34312c1a_nasa_logo.png",
                alt: {
                    ES: "NASA_logo.svg.png"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            }
        }
    ],
    education: [
        {
            type: "DEGREE",
            title: {
                ES: "Mathematics"
            },
            institution: "University of Michigan",
            description: {
                ES: ""
            },
            from: "1950-05-01T12:00:00.000Z",
            to: "1955-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/96b1aaf2-f74a-4d62-8ca5-cee74f92eb54_225px-seal_of_the_un.png",
                alt: {
                    ES: "225px-Seal_of_the_University_of_Michigan.svg.png"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            }
        },
        {
            type: "DEGREE",
            title: {
                ES: "BA in Mathematics"
            },
            institution: "Earlham College",
            description: {
                ES: ""
            },
            from: "1955-05-01T12:00:00.000Z",
            to: "1958-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/429c9f38-2581-4d2c-88be-e2d292360a53_earlham_college_seal.png",
                alt: {
                    ES: "Earlham_College_Seal.png"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            }
        },
        {
            type: "DEGREE",
            title: {
                ES: "Minor in Philosophy"
            },
            institution: "Earlham College",
            description: {
                ES: ""
            },
            from: "1957-05-01T12:00:00.000Z",
            to: "1958-05-01T12:00:00.000Z",
            techs: [],
            logo: {
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/27/9749545c-bcce-49e6-ab8f-1d3604deb887_earlham_college_seal.png",
                alt: {
                    ES: "Earlham_College_Seal.png"
                },
                id: 1,
                title: "",
                filename: "",
                ownerId: 1,
                uploadPath: ""
            }
        }
    ],
    certifications: [],
    bookmarks: [
        {
            type: "READING",
            title: {
                ES: "Margaret Hamilton, the woman who coded Apollo 11's software"
            },
            category: {
                ES: ""
            },
            author: "El Pa\xeds",
            description: {
                ES: ""
            },
            url: "https://elpais.com/tecnologia/2018/10/22/actualidad/1540207046_513939.html",
            logo: {
                id: 18925,
                filename: "el-pais.svg",
                title: "el-pais.svg",
                url: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/28/3eb5d34e-d2eb-4c4d-bb53-a2541393c0cd_el-pais.svg",
                uploadPath: "https://media-asgard.s3.eu-west-1.amazonaws.com/22/07/28/3eb5d34e-d2eb-4c4d-bb53-a2541393c0cd_el-pais.svg",
                alt: {
                    ES: "el-pais.svg"
                },
                ownerId: 8548
            }
        }
    ],
    views: {
        publicProfileDefaultView: "classic",
        publicProfileIndexable: false
    }
};
/* harmony default export */ var CVApplicationTermsNotAcceptedComponent_data = (CvApplicationSampleManfredite);

;// CONCATENATED MODULE: ./components/cvApplications/view/CVApplicationTermsNotAcceptedComponent.styled.ts

function CVApplicationTermsNotAcceptedComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  filter: blur(1rem);\n"
    ]);
    CVApplicationTermsNotAcceptedComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledBlurred = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c72d5de3-0"
})(CVApplicationTermsNotAcceptedComponent_styled_templateObject());

;// CONCATENATED MODULE: ./components/cvApplications/view/CVApplicationTermsNotAcceptedComponent.tsx








var CVApplicationTermsNotAcceptedComponent = function(param) {
    var jobApplicationResume = param.jobApplicationResume, viewCvType = param.viewCvType, onAcceptTermsClick = param.onAcceptTermsClick;
    var t = (0,useI18n/* useI18n */.Q)("cv-applications-view").t;
    var title = t("cvApplicationsView.termsNotAccepted.title", {
        fullName: "".concat(jobApplicationResume.firstName, " ").concat(jobApplicationResume.lastName)
    });
    var desc = t("cvApplicationsView.termsNotAccepted.desc");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
            noTopBar: true,
            noFooter: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                    title: title,
                    desc: desc
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBlurred, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(publicProfile_PublicProfileComponent, {
                        publicManfredite: CVApplicationTermsNotAcceptedComponent_data,
                        type: viewCvType,
                        isDefaultView: false,
                        sendVisitTrackEvent: false
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(termsAndConditions_CVApplicationsTermsModalComponent, {
                    isOpen: true,
                    onAccept: onAcceptTermsClick,
                    jobApplicationResume: jobApplicationResume
                })
            ]
        })
    });
};
/* harmony default export */ var view_CVApplicationTermsNotAcceptedComponent = (CVApplicationTermsNotAcceptedComponent);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ./components/cvApplications/view/CVApplicationViewComponent.reducer.tsx


var CVApplicationViewActionType;
(function(CVApplicationViewActionType) {
    CVApplicationViewActionType["ACCEPT_TERMS"] = "ACCEPT_TERMS";
})(CVApplicationViewActionType || (CVApplicationViewActionType = {}));
function CVApplicationViewReducer(state, action) {
    var type = action.type, payload = action.payload;
    switch(type){
        case CVApplicationViewActionType.ACCEPT_TERMS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                termsAndConditionsAccepted: true,
                publicManfredite: payload.data.publicManfredite,
                cvApplication: payload.data.jobApplication
            });
        default:
            throw new Error("Invalid action type must be any of: ".concat(Object.values(CVApplicationViewActionType)));
    }
}

;// CONCATENATED MODULE: ./components/cvApplications/view/CVApplicationViewComponent.tsx












var CVApplicationViewComponent = function(props) {
    var t = (0,useI18n/* useI18n */.Q)("cv-applications-view").t;
    var addErrorToast = (0,useToasts/* useToasts */.e)().addErrorToast;
    var user = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi).user;
    var ref = (0,react.useReducer)(CVApplicationViewReducer, {
        termsAndConditionsAccepted: props.termsAndConditionsAccepted,
        jobApplicationResume: props.jobApplicationResume,
        publicManfredite: props.publicManfredite,
        cvApplication: props.cvApplication
    }), state = ref[0], dispatch = ref[1];
    var handleTermsAcceptedClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var jobApp, ex;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (props.previewMode) {
                            dispatch({
                                type: CVApplicationViewActionType.ACCEPT_TERMS,
                                payload: {
                                    data: {
                                        jobApplicationResume: props.jobApplicationResume,
                                        jobApplication: props.cvApplication,
                                        publicManfredite: props.publicManfredite
                                    }
                                }
                            });
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            manfredite_job_application_service/* default.acceptTermsAndConditions */.Z.acceptTermsAndConditions(props.slug)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            manfredite_job_application_service/* default.getBySlug */.Z.getBySlug(props.slug, user === null || user === void 0 ? void 0 : user.id)
                        ];
                    case 3:
                        jobApp = _state.sent();
                        if (!jobApp.publicManfredite) {
                            throw new Error("Could not accept terms and conditions for this cv application");
                        }
                        dispatch({
                            type: CVApplicationViewActionType.ACCEPT_TERMS,
                            payload: {
                                data: jobApp
                            }
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        ex = _state.sent();
                        console.error("Could not accept terms and conditions for job app ".concat(props.slug, ", by Manfredite: ").concat(user === null || user === void 0 ? void 0 : user.id, ". Exception: ").concat(ex, "}"));
                        addErrorToast(t("cvApplicationsView.modalTerms.messages.error.acceptTerms", {
                            error: (0,errors/* getErrorMessage */.e)(ex)
                        }));
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleTermsAcceptedClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !state.termsAndConditionsAccepted && /*#__PURE__*/ (0,jsx_runtime.jsx)(view_CVApplicationTermsNotAcceptedComponent, {
                jobApplicationResume: state.jobApplicationResume,
                onAcceptTermsClick: handleTermsAcceptedClick,
                viewCvType: props.jobApplicationResume.view
            }),
            state.termsAndConditionsAccepted && state.publicManfredite && state.cvApplication && /*#__PURE__*/ (0,jsx_runtime.jsx)(view_CVApplicationTermsAcceptedComponent, {
                publicManfredite: state.publicManfredite,
                jobApplicationResume: state.jobApplicationResume,
                cvApplication: state.cvApplication,
                previewMode: props.previewMode
            })
        ]
    });
};
/* harmony default export */ var view_CVApplicationViewComponent = (CVApplicationViewComponent);


/***/ }),

/***/ 11472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ StyledAvatar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: ",
        ";\n      height: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  border: 0;\n  border-radius: ",
        ";\n  transition: 0.3s;\n\n  img {\n    display: block;\n    object-fit: cover;\n    border-radius: 50%;\n    height: 100%;\n    width: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var sizeVariants = {
    sm: {
        width: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"),
        height: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl")
    },
    lg: {
        width: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"),
        height: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4")
    }
};
var StyledAvatar = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7188bb60-0"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("full"), function(param) {
    var sizes = param.sizes;
    return sizes && sizeVariants[sizes] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), sizeVariants[sizes].width, sizeVariants[sizes].height);
});


/***/ }),

/***/ 6937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _Avatar_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11472);





var Avatar = function(_param) {
    var avatarImg = _param.avatarImg, avatarAlt = _param.avatarAlt, className = _param.className, sizes = _param.sizes, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "avatarImg",
        "avatarAlt",
        "className",
        "sizes"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: avatarImg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Avatar_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledAvatar */ .b, {
            className: className,
            sizes: sizes,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
                width: 40,
                height: 40,
                src: decodeURI(avatarImg),
                alt: avatarAlt
            }))
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);


/***/ }),

/***/ 5577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ uploadManfrediteFile; },
/* harmony export */   "_I": function() { return /* binding */ deleteFile; },
/* harmony export */   "iE": function() { return /* binding */ getFileDownloadLink; }
/* harmony export */ });
/* unused harmony exports getFile, downloadManfrediteMedia, uploadFile, MediaService */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22970);
/* harmony import */ var utils_fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89608);



var BASE_URL = "".concat("", "/api/manfredite/file");
/**
 * Gets a file from current logged in Manfredite
 *
 * @param id - identifier for the required file
 * @returns the Media file
 */ function getFile(id) {
    return _getFile.apply(this, arguments);
}
function _getFile() {
    _getFile = _async_to_generator(function(id) {
        var res;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch.get("".concat(BASE_URL, "/").concat(id))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return _getFile.apply(this, arguments);
}
/**
 * Gets a file download URL from current logged in Manfredite
 *
 * @param id - identifier for the required file
 * @returns the Media file download URL
 *
 * @deprecated use ServiceManfrediteMedia.getFileDownloadLink instead
 */ function getFileDownloadLink(id) {
    return _getFileDownloadLink.apply(this, arguments);
}
function _getFileDownloadLink() {
    _getFileDownloadLink = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_fetch__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2("".concat(BASE_URL, "/").concat(id, "/download"))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return _getFileDownloadLink.apply(this, arguments);
}
function downloadManfrediteMedia(media) {
    return _downloadManfrediteMedia.apply(this, arguments);
}
function _downloadManfrediteMedia() {
    _downloadManfrediteMedia = _async_to_generator(function(media) {
        var downloadLink, link;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getFileDownloadLink(media.id)
                    ];
                case 1:
                    downloadLink = _state.sent();
                    link = document.createElement("a");
                    link.href = downloadLink;
                    link.download = media.filename || "unknown-file";
                    link.click();
                    return [
                        2
                    ];
            }
        });
    });
    return _downloadManfrediteMedia.apply(this, arguments);
}
/**
 * Uploads a file which will be owned by current logged in Manfredite
 *
 * @param file - the file to upload
 * @returns the Media file
 *
 * @deprecated use ServiceManfrediteMedia.uploadImage instead
 */ function uploadManfrediteFile(file, type) {
    return _uploadManfrediteFile.apply(this, arguments);
}
function _uploadManfrediteFile() {
    _uploadManfrediteFile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file, type) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                uploadFile({
                    type: type,
                    title: file.name,
                    alt: {
                        ES: file.name
                    },
                    file: file
                })
            ];
        });
    });
    return _uploadManfrediteFile.apply(this, arguments);
}
/**
 * Uploads a file which will be owned by current logged in Manfredite
 *
 * @param params - the file and file info to upload
 * @returns the Media file
 */ function uploadFile(params) {
    return _uploadFile.apply(this, arguments);
}
function _uploadFile() {
    _uploadFile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(params) {
        var uploadMediaParams, _file, _title, _alt, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    uploadMediaParams = new FormData();
                    uploadMediaParams.append("attached", (_file = params.file) !== null && _file !== void 0 ? _file : "");
                    uploadMediaParams.append("title", (_title = params.title) !== null && _title !== void 0 ? _title : "");
                    uploadMediaParams.append("alt", JSON.stringify((_alt = params.alt) !== null && _alt !== void 0 ? _alt : ""));
                    return [
                        4,
                        utils_fetch__WEBPACK_IMPORTED_MODULE_0__/* .post */ .v_("".concat(BASE_URL, "/").concat(params.type), uploadMediaParams, {
                            headers: {}
                        })
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data.data
                    ];
            }
        });
    });
    return _uploadFile.apply(this, arguments);
}
/**
 * Removes a file owned by the current logged in Manfredite
 *
 * @param id - the file to be removed
 * @returns nothing
 *
 * @deprecated use ServiceManfrediteMedia.deleteMedia instead
 */ function deleteFile(id) {
    return _deleteFile.apply(this, arguments);
}
function _deleteFile() {
    _deleteFile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                utils_fetch__WEBPACK_IMPORTED_MODULE_0__/* ._delete */ .ZJ("".concat(BASE_URL, "/").concat(id))
            ];
        });
    });
    return _deleteFile.apply(this, arguments);
}
var MediaService = {
    deleteFile: deleteFile,
    uploadFile: uploadFile,
    uploadManfrediteFile: uploadManfrediteFile
};


/***/ }),

/***/ 72971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22970);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75339);
/* harmony import */ var utils_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89608);




var ENDPOINT_PATH = "/public/manfredite/job-application";
var API_BASE_URL = "".concat(utils_config__WEBPACK_IMPORTED_MODULE_0__/* .config.apiUrl */ .v.apiUrl).concat(ENDPOINT_PATH);
function getBySlug(slug, manfrediteId) {
    return _getBySlug.apply(this, arguments);
}
function _getBySlug() {
    _getBySlug = /**
 * Get a Job Application of a Manfredite by its slug
 *
 * @param slug - The Job Application slug
 * @param manfrediteId - ID of the currently manfredite logged ID (if logged)
 *
 * @returns the Job Application (Manfredite profile, summary info and CV Application info).
 */ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug, manfrediteId) {
        var baseUrl, params, res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    baseUrl = API_BASE_URL;
                    params = new URLSearchParams();
                    if (manfrediteId) {
                        params.set("manfrediteId", manfrediteId.toString());
                    }
                    return [
                        4,
                        utils_fetch__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2("".concat(baseUrl, "/").concat(slug, "?").concat(params))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return _getBySlug.apply(this, arguments);
}
function acceptTermsAndConditions(slug) {
    return _acceptTermsAndConditions.apply(this, arguments);
}
function _acceptTermsAndConditions() {
    _acceptTermsAndConditions = /**
 * Accept the terms and conditions of a given Job Application slug
 *
 * @param slug - The slug of the Job application to accept the terms and conditions
 */ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var baseUrl;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            baseUrl = API_BASE_URL;
            return [
                2,
                utils_fetch__WEBPACK_IMPORTED_MODULE_1__/* .put */ .gz("".concat(baseUrl, "/").concat(slug, "/accept-privacy-terms"), {})
            ];
        });
    });
    return _acceptTermsAndConditions.apply(this, arguments);
}
var ManfrediteJobApplicationService = {
    getBySlug: getBySlug,
    acceptTermsAndConditions: acceptTermsAndConditions
};
/* harmony default export */ __webpack_exports__["Z"] = (ManfrediteJobApplicationService);


/***/ }),

/***/ 74679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CU": function() { return /* reexport */ EMAIL_REGEX; },
  "pv": function() { return /* reexport */ GITHUB_URL_OR_EMPTY_REGEX; },
  "f5": function() { return /* reexport */ LINKEDIN_PROFILE_URL_OR_EMPTY_REGEX; },
  "oS": function() { return /* reexport */ SO_DEV_STORY_URL_REGEX; },
  "_B": function() { return /* reexport */ SO_URL_OR_EMPTY_REGEX; },
  "x5": function() { return /* reexport */ TWITTER_URL_OR_EMPTY_REGEX; },
  "Yl": function() { return /* reexport */ URL_OR_EMPTY_REGEX; },
  "Cx": function() { return /* reexport */ isValidGitHubURL; },
  "_C": function() { return /* reexport */ isValidSOURL; },
  "pn": function() { return /* reexport */ isValidTwitterURL; },
  "T6": function() { return /* reexport */ isValidURLOrEmpty; }
});

// UNUSED EXPORTS: CURRENCY_LIST, GITHUB_URL_REGEX, LINKEDIN_IMAGE_URL_REGEX, LINKEDIN_PROFILE_URL_REGEX, MANFREDITE_PROFILE_SLUG_URL_OR_EMPTY_REGEX, MANFREDITE_PROFILE_URL_OR_EMPTY_REGEX, MANFREDITE_PROFILE_URL_REGEX, SO_URL_REGEX, TWITTER_URL_REGEX, URL_REGEX, extractLastUrlSegment, getFakeAvatarUrl, getLinkedinUsernameFromUrl, getSecondsBetweenDates, getSecondsUntilNow, getWeekNumber, isValidDevStorySOURL, isValidLinkedinImageUrl, isValidLinkedinUrl, isValidManfrediteProfileUrl, isValidURL

;// CONCATENATED MODULE: ../utils/dist/esm/data/index.js
const CURRENCY_LIST = [
    {
        label: 'currency.euro',
        value: '€'
    },
    {
        label: 'currency.usdollar',
        value: 'US$'
    },
    {
        label: '----------------',
        value: ''
    },
    {
        label: 'currency.australiandollar',
        value: 'A$'
    },
    {
        label: 'currency.canadiandollar',
        value: 'C$'
    },
    {
        label: 'currency.hongkongdollar',
        value: 'HK$'
    },
    {
        label: 'currency.japaneseyen',
        value: '¥'
    },
    {
        label: 'currency.mexicanpeso',
        value: 'MXN$'
    },
    {
        label: 'currency.pundsterling',
        value: '£'
    },
    {
        label: 'currency.renminbi',
        value: 'CNY'
    },
    {
        label: 'currency.russianruble',
        value: '₽'
    },
    {
        label: 'currency.singaporedollar',
        value: 'S$'
    },
    {
        label: 'currency.swedishkrona',
        value: 'SEK'
    },
    {
        label: 'currency.argentinianpeso',
        value: 'ARS$'
    },
    {
        label: 'currency.brizilianreal',
        value: 'R$'
    },
    {
        label: 'currency.chileanpeso',
        value: 'CLP$'
    },
    {
        label: 'currency.colombianpeso',
        value: 'COL$'
    },
    {
        label: 'currency.czechkoruna',
        value: 'Kč'
    },
    {
        label: 'currency.danishkrone',
        value: 'DKK'
    },
    {
        label: 'currency.israelinewshekel',
        value: '₪'
    },
    {
        label: 'currency.norwegiankrone',
        value: 'NOK'
    },
    {
        label: 'currency.polishzloti',
        value: 'zł'
    },
    {
        label: 'currency.swissfranc',
        value: 'CHF'
    }
];
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../utils/dist/esm/validation/index.js
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const URL_REGEX = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;
const URL_OR_EMPTY_REGEX = /^$|(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;
const SO_DEV_STORY_URL_REGEX = /^https:\/\/(www\.)?stackoverflow\.com\/(story|cv|users\/story)\/(.)+$/i;
function isValidDevStorySOURL(url) {
    return SO_DEV_STORY_URL_REGEX.test(url);
}
const SO_URL_REGEX = /^https:\/\/(www\.)?stackoverflow\.com\/users\/(.)+$/i;
const SO_URL_OR_EMPTY_REGEX = /^$|https:\/\/(www\.)?stackoverflow\.com\/users\/(.)+$/i;
function isValidSOURL(url) {
    return SO_URL_REGEX.test(url);
}
const TWITTER_URL_REGEX = /^https:\/\/(www\.)?(twitter\.com|x\.com)\/(.)+$/i;
const TWITTER_URL_OR_EMPTY_REGEX = /^$|https:\/\/(www\.)?(twitter\.com|x\.com)\/(.)+$/i;
function isValidTwitterURL(url) {
    return TWITTER_URL_REGEX.test(url);
}
const GITHUB_URL_REGEX = /^https:\/\/(www\.)?github\.com\/(.)+$/i;
const GITHUB_URL_OR_EMPTY_REGEX = /^$|https:\/\/(www\.)?github\.com\/(.)+$/i;
function isValidGitHubURL(url) {
    return GITHUB_URL_REGEX.test(url);
}
function isValidURL(url) {
    return URL_REGEX.test(url);
}
function isValidURLOrEmpty(url) {
    return URL_OR_EMPTY_REGEX.test(url);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../utils/dist/esm/linkedin/linkedin-utils.js
const LINKEDIN_PROFILE_URL_REGEX = /^(https:\/\/)?(\S{2,4}\.)?linkedin.com\/in\/([^?/\s]+)[/]?$/i;
const LINKEDIN_IMAGE_URL_REGEX = /^(https:\/\/)media.licdn.com\/.+$/i;
const LINKEDIN_PROFILE_URL_OR_EMPTY_REGEX = /^$|((https:\/\/)?(\S{2,4}\.)?linkedin.com\/in\/([^?/\s]+)[/]?)$/i;
function isValidLinkedinImageUrl(url) {
    const isValid = LINKEDIN_IMAGE_URL_REGEX.test(url);
    return isValid;
}
function isValidLinkedinUrl(url) {
    const isValid = LINKEDIN_PROFILE_URL_REGEX.test(url);
    return isValid;
}
function getLinkedinUsernameFromUrl(url) {
    const matches = LINKEDIN_PROFILE_URL_REGEX.exec(url);
    if (!matches || matches.length < 4 || !matches[3]) {
        throw new Error(`[getLinkedinUsernameFromUrl] error retrieving username from url: ${url}`);
    }
    const username = (matches[3] || '').replace('/', '');
    return username;
}
//# sourceMappingURL=linkedin-utils.js.map
;// CONCATENATED MODULE: ../utils/dist/esm/index.js







//# sourceMappingURL=index.js.map

/***/ })

}]);